import { createContext } from 'react';

type EmbedShowCaseData = {
  isShowcaseEmbeded: boolean;
  referrer: string;
};

export const EmbedShowcaseContext = createContext<EmbedShowCaseData | undefined>({
  isShowcaseEmbeded: false,
  referrer: '',
});
